/* Sol Calypso: size selector inside the product page's sticky bar.

   The bar carried a quantity stepper and an Add to bag button but no way to
   change size, so from halfway down the page the only route to another size
   was scrolling back up to the panel.

   Deliberately a mirror rather than a second control. sc-product-page.js binds
   each pill individually and resolves the variant by reading every
   [data-sc-opt] group, so a cloned group would be counted as an extra option
   and resolution would fail. These buttons forward their click to the real
   pill and watch it for the resulting state, which leaves the variant logic
   exactly where it already was. */
(function () {
  var root = document.querySelector('.sc-pd');
  if (!root) return;

  var sticky = root.querySelector('[data-sc-sticky]');
  var addBtn = sticky && sticky.querySelector('[data-sc-stickyadd]');
  if (!sticky || !addBtn) return;
  if (sticky.querySelector('.sc-pd__stickysizes')) return;

  var groups = [].slice.call(root.querySelectorAll('[data-sc-opt]'));
  if (!groups.length) return;

  function named(g) {
    var n = g.querySelector('.sc-pd__optname');
    return n ? n.textContent.trim().toLowerCase() : '';
  }

  /* The size row by name, the same guess the section makes when it decides
     where to hang the size guide. Falls back to the first group that actually
     offers a choice. */
  var source = groups.filter(function (g) {
    var n = named(g);
    return n.indexOf('size') > -1 || n.indexOf('talla') > -1;
  })[0];

  if (!source) {
    source = groups.filter(function (g) {
      return g.querySelectorAll('.sc-pd__pill').length > 1;
    })[0];
  }
  if (!source) return;

  var pills = [].slice.call(source.querySelectorAll('.sc-pd__pill'));
  if (pills.length < 2) return;

  var wrap = document.createElement('div');
  wrap.className = 'sc-pd__stickysizes';
  wrap.setAttribute('role', 'group');
  wrap.setAttribute('aria-label', named(source) || 'Size');

  var pairs = pills.map(function (src) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sc-pd__stickysize';
    btn.textContent = src.textContent.trim();
    btn.addEventListener('click', function () { src.click(); });
    wrap.appendChild(btn);
    return { btn: btn, src: src };
  });

  sticky.insertBefore(wrap, addBtn);

  function sync() {
    pairs.forEach(function (p) {
      var on = p.src.classList.contains('is-on');
      p.btn.classList.toggle('is-on', on);
      p.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      p.btn.disabled = p.src.disabled;
    });
  }
  sync();

  /* The real pills stay the source of truth, so the mirror follows whatever
     marks them: a tap here, a tap up in the panel, or anything else that ends
     up setting is-on. */
  var obs = new MutationObserver(sync);
  pills.forEach(function (src) {
    obs.observe(src, { attributes: true, attributeFilter: ['class', 'disabled'] });
  });
})();
